var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlotWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9995 12.7598L23.6726 16.6776C28.6635 12.8547 28.6635 8.73562 28.6635 8.73562L22.0409 14.9959C26.4982 7.91559 24.8665 5 24.8665 5L19.5915 13.5304C18.4344 13.2248 17.2418 13.0704 16.0441 13.0711H15.9597C14.762 13.0704 13.5694 13.2248 12.4123 13.5304L7.13728 5C7.13728 5 5.29063 7.67644 9.74791 14.7567L3.35185 8.73562C3.35185 8.73562 2.69918 12.3953 8.03177 16.4499C8.00489 16.4916 2.00046 12.7598 2.00046 12.7598C2.00046 12.7598 1.84689 16.2752 7.13728 19.0959V19.187C7.13728 23.01 11.0801 26.9582 15.9673 27H16.0518C20.9314 26.9582 24.8819 23.01 24.8819 19.187V19.0959C30.1531 16.2752 29.9995 12.7598 29.9995 12.7598ZM13.0151 23.029C13.0151 23.029 11.4487 23.1277 10.5464 22.2355C9.64422 21.3434 9.75559 19.7983 9.75559 19.7983C9.75559 19.7983 11.322 19.6957 12.2242 20.5917C13.1264 21.4876 13.0151 23.029 13.0151 23.029ZM21.4612 22.2355C20.559 23.1277 18.9965 23.029 18.9965 23.029C18.9965 23.029 18.8966 21.4838 19.7989 20.5917C20.701 19.6995 22.2636 19.7983 22.2636 19.7983C22.2636 19.7983 22.3519 21.3434 21.4458 22.2355H21.4612Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlotWhite);
export default __webpack_public_path__ + "static/media/alot-white.f723c2bd394e9f8a0b7c53aba7c614e2.svg";
export { ForwardRef as ReactComponent };